import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { MainLayout } from '../components/layout';
import { Icon } from '../components/ui';
import TokenManager from '../utils/tokenManager';
import { homePathFor, ROLE_LABEL } from '../config/navigation';
import '../styles/Unauthorized.scss';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const signedIn = TokenManager.hasValidToken();
  const payload = signedIn ? TokenManager.getUserFromToken(TokenManager.getAccessToken() || '') || {} : {};
  const roles: string[] = Array.isArray(payload.roles) ? payload.roles : [];
  const role = roles.includes('admin') ? 'admin' : roles.includes('org_manager') ? 'org_manager' : roles[0] || 'customer';

  const switchAccount = () => {
    TokenManager.clearToken();
    navigate('/login');
  };

  const content = (
    <div className="no-access">
      <div className="no-access__mark">
        <img src="/brand/duoduopin-mark-256.png" alt="" width={64} height={64} />
        <span><Icon name="lock" size={18} /></span>
      </div>
      <h2>没有访问权限</h2>
      <p>
        {signedIn ? `当前账号的角色是「${ROLE_LABEL[role] || role}」，无法查看这个页面。` : '登录状态已失效，或当前账号没有这个页面的权限。'}
        <br />
        如需开通，请联系你所在组织的管理员。
      </p>
      <div className="no-access__actions">
        {signedIn ? (
          <>
            <Button type="primary" icon={<Icon name="arrowL" />} onClick={() => navigate(homePathFor(roles))}>
              返回我的工作台
            </Button>
            <Button onClick={switchAccount}>切换账号</Button>
          </>
        ) : (
          <>
            <Button type="primary" onClick={() => navigate('/login')}>
              重新登录
            </Button>
            <Button onClick={() => navigate('/')}>返回首页</Button>
          </>
        )}
      </div>
      <p className="no-access__code">错误代码 <span className="mono">4001</span></p>
    </div>
  );

  if (signedIn) {
    return (
      <MainLayout title="没有访问权限" description="该页面需要更高的角色权限">
        {content}
      </MainLayout>
    );
  }

  return <div className="no-access-page">{content}</div>;
};

export default Unauthorized;
